module.exports = __webpack_public_path__ + "img/logout.b1be50b0.svg";